import { Image } from '@/atoms/Image'
import { Text } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { DavidButton } from './DavidButton'

export const DavidEpisodesSection = () => {
  const { t } = useTranslate('pif')

  return (
    <div
      style={{ background: 'linear-gradient(180deg, rgba(21, 21, 21, 0.75) 0%, rgba(21, 21, 21, 0) 100%)' }}
      className="relative w-full"
    >
      <div className="mx-auto w-full max-w-[1440px] px-4 pb-12 pt-[5rem] md:items-center md:px-12 md:pb-[4rem] md:pt-[7.5rem] lg:px-[4rem] lg:pb-[6rem] lg:pt-[10rem] xl:grid xl:grid-cols-2">
        <div className="order-2">
          <Image
            src="/v1763166873/theatrical/david/young-david-nopad-color-tm.webp"
            alt="David Logo"
            className="h-[79px] w-[200px] md:h-[119px] md:w-[300px]"
            width={300}
            height={119}
          />

          <p className="font-angel-royal relative mt-6 text-5xl lowercase not-italic leading-[2.5rem] text-white md:text-[3.5rem] md:leading-[3rem]">
            {t('davidUnlockEpisodesTitle', 'Unlock Young David Episodes 1-3 Today')}
          </p>

          <Text className="photon-paragraph-md md:photon-paragraph-lg mt-3 !text-[#C9EDF2]">
            {t(
              'davidUnlockEpisodesDescription',
              'Pay it Forward in any amount and unlock instant streaming access to the first three episodes of Young DAVID.',
            )}
          </Text>
          <DavidButton variant="cyan" openPifOverlay className="mr-auto mt-8 md:mt-10">
            {t('payItForward', 'Pay it Forward')}
          </DavidButton>
        </div>

        <div className="order-1 mt-10">
          <div className="flex items-center gap-6 md:gap-8 xl:justify-center xl:gap-12">
            <Image
              src="/v1763166701/theatrical/david/yd-e01-graphic-01.png"
              alt="David Episode 1"
              className="h-[150px] w-[120px] md:h-[225px] md:w-[180px]"
              width={180}
              height={225}
            />
            <Image
              src="/v1763413931/theatrical/david/yd-ep1-content_2x.webp"
              alt="Warrior Episode 1"
              className="h-[64px] w-[183px] md:h-[80px] md:w-[228px] lg:h-[88px] lg:w-[251px]"
              width={237}
              height={83}
            />
          </div>

          <div className="flex items-center gap-6 md:gap-8 lg:gap-12 xl:flex-row-reverse xl:justify-center">
            <Image
              src="/v1763166701/theatrical/david/yd-e02-graphic-01.webp"
              alt="David Episode 2"
              className="h-[150px] w-[120px] md:h-[225px] md:w-[180px]"
              width={188}
              height={225}
            />
            <Image
              src="/v1763413932/theatrical/david/yd-ep2-content_2x.webp"
              alt="King Episode 2"
              className="h-[64px] w-[93px] md:h-[80px] md:w-[117px] lg:h-[88px] lg:w-[128px]"
              width={128}
              height={83}
            />
          </div>

          <div className="flex items-center gap-6 md:gap-8 xl:justify-center xl:gap-12">
            <Image
              src="/v1763166701/theatrical/david/yd-e03-graphic-01.webp"
              alt="David Episode 3"
              className="h-[150px] w-[120px] md:h-[225px] md:w-[180px]"
              width={188}
              height={225}
            />
            <Image
              src="/v1763506136/theatrical/david/yd-ep3-content_2x.webp"
              alt="Shepperd Episode 3"
              className="h-[64px] w-[177px] md:h-[80px] md:w-[221px] lg:h-[88px] lg:w-[243px]"
              width={243}
              height={83}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
